const time = (value) => {
    if (!value) return undefined;
    const pattr = new RegExp(/^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/);
    return !pattr.test(value) ? 'Please enter time in correct 24 hour format (HH:MM)!' : undefined;
}
export default time;


